// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const SellerReviewsClient = registerClientReference(
    function() { throw new Error("Attempted to call SellerReviewsClient() from the server but SellerReviewsClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(seller)/seller/reviews/seller-reviews-client.tsx",
    "SellerReviewsClient",
);
